import classNames from 'classnames';
import React from 'react';
import { Button } from 'react-bootstrap';
import { BsSortAlphaDown, BsSortAlphaDownAlt, BsSortNumericDown, BsSortNumericDownAlt } from 'react-icons/bs';
import { ISourceBase } from '../../interfaces/sources';
import { SOURCE_ORDER_DEFAULT } from './manageSlice';

interface IOrderButtonProps extends React.AllHTMLAttributes<HTMLDivElement> {
	selectedOrderField: keyof ISourceBase;
	onOrderClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
	orderField: keyof ISourceBase;
	selectedOrderAsc: boolean;
}
const OrderButton = ({ selectedOrderField, onOrderClick, orderField, selectedOrderAsc }: IOrderButtonProps) => {
	const isSelected = orderField === selectedOrderField;
	const isAlpha = SOURCE_ORDER_DEFAULT[orderField]?.isAlpha;
	// Сортування на іконці
	const iconOrderAsc = isSelected ? selectedOrderAsc : SOURCE_ORDER_DEFAULT[orderField]?.asc;
	const Icon = isAlpha
		? iconOrderAsc
			? BsSortAlphaDown
			: BsSortAlphaDownAlt
		: iconOrderAsc
		? BsSortNumericDown
		: BsSortNumericDownAlt;
	// if (orderField === selectedOrderField) console.log({ orderField, selectedOrderAsc, isAlpha });

	return (
		<Button
			variant="link"
			data-order={orderField}
			className={classNames('ms-2 p-0', isSelected ? 'link-primary' : 'link-secondary')}
			onClick={onOrderClick}
		>
			<Icon className="icon-lg mt-n1" />
		</Button>
	);
};

export default OrderButton;
